export function getGridStyle(tokens) {
    return {
        display: "grid",
        gap: tokens.childrenGap,
        gridTemplateColumns: `repeat(${tokens.columns}, 1fr)`,
    };
}
